var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrowDoubleHeadLeft = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4893 16.3999L9.93316 10.3485C9.89107 10.3027 9.85767 10.2484 9.83489 10.1886C9.8121 10.1288 9.80037 10.0647 9.80037 9.9999C9.80037 9.93515 9.8121 9.87103 9.83489 9.81122C9.85767 9.75141 9.89107 9.69708 9.93316 9.65135L15.4893 3.5999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68945 16.3999L4.13336 10.3485C4.09126 10.3027 4.05787 10.2484 4.03508 10.1886C4.01229 10.1288 4.00056 10.0647 4.00056 9.9999C4.00056 9.93515 4.01229 9.87103 4.03508 9.81122C4.05787 9.75141 4.09126 9.69708 4.13336 9.65135L9.68945 3.5999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowDoubleHeadLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrowDoubleHeadLeft.b7de1798.svg";
export { ForwardRef as ReactComponent };